import script from "./ActivityAlertCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityAlertCard.vue?vue&type=script&setup=true&lang=js"

import "./ActivityAlertCard.vue?vue&type=style&index=0&id=78125db0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78125db0"]])

export default __exports__